import Markdown from "markdown-to-jsx";
import Image from 'next/image'
import styles from "./missaoCompromisso.module.css";

export default function Porque({ data }) {
  return (
    <section
      className={`container-full ${styles.container}`}
      style={{
        backgroundImage: `url(${data.imagem.url})`,
        backgroundRepeat: 'no-repeat, repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'right',
        backgroundColor: '#D72E3F',
        // width: '900px'
      }}
    >
      {/* <div className={styles.placeholder} /> */}
      <div className={`flex-column flex-lg-row ${styles.content}`}>
        <div className={styles.bgImg}>
          {/* <Image
            src={data.imagem.url}
            width={933}
            height={662}
            objectFit="contain"
            layout="responsive"
            responsive
          /> */}
        </div>
        <div className={styles.infoContent}>
          <div className={styles.title}>
            <div className={styles.parallelogramDetailWhite} />
            <h2>{data.titulo}</h2>
          </div>
          <div className={styles.description}>
            <Markdown>{data.descricao}</Markdown>
          </div>
        </div>
      </div>
    </section>
  );
}
